import { render, staticRenderFns } from "./localeChanger.vue?vue&type=template&id=9e774df8&"
import script from "./localeChanger.vue?vue&type=script&lang=js&"
export * from "./localeChanger.vue?vue&type=script&lang=js&"
import style0 from "./localeChanger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
